module.exports = __webpack_public_path__ + "img/file-pdf2.7a93f17e.svg";